import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";

/**
 * Reusable destructive-action confirmation dialog wrapping shadcn AlertDialog.
 *
 * Usage:
 *   const [confirming, setConfirming] = useState(null); // {title, description}
 *   <ConfirmDialog open={!!confirming} title={confirming?.title} description={confirming?.description}
 *                  onConfirm={() => { confirming.action(); setConfirming(null); }}
 *                  onCancel={() => setConfirming(null)}/>
 */
export default function ConfirmDialog({
  open,
  title = "Are you sure?",
  description,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  destructive = true,
  onConfirm,
  onCancel,
  testid = "confirm-dialog",
}) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel?.(); }}>
      <AlertDialogContent data-testid={testid}>
        <AlertDialogHeader>
          <AlertDialogTitle data-testid={`${testid}-title`}>{title}</AlertDialogTitle>
          {description && (
            <AlertDialogDescription data-testid={`${testid}-desc`} className="whitespace-pre-line leading-relaxed">
              {description}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel`} onClick={onCancel}>
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testid}-confirm`}
            onClick={onConfirm}
            className={destructive ? "bg-red-600 hover:bg-red-700 focus:ring-red-500" : undefined}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
